// extracted by mini-css-extract-plugin
export default {"page":"Profile_page__ZcCNv","dark":"Profile_dark__o0Gle","light":"Profile_light__tnQFh"};